import store from '@/store/index'
import i18n from "@/i18n";

function callback(obj: any, res: any){
  store.dispatch('setLoading', true)
  store.dispatch('submitProposal', obj).then(() => {
    store.dispatch('setLoading', false)
    store.dispatch('clearFormData')
    const popup = {
      title: i18n.global.t(
        `proposal.form.popups.success.title`
      ),
      align: 'center',
      side: false,
      iconBg: 'bg-green-5',
      icon: '/img/done_step.svg',
      content: i18n.global.t(
        `proposal.form.popups.success.body`
      ),
      primaryButton: i18n.global.t(
        `proposal.form.popups.success.btn`
      ),
      primaryLink: res.type ? '/login' : '/signup',
      bgLink: res.type ? '/login' : '/signup',
      sideBySideButtons: false
    }
    store.dispatch('setPopup', popup)
    return true
  })
}

const handle_submit = () => {
  return new Promise((resolve, reject) => {

    store.dispatch('setLoading', true)

    const obj = {
      ...store.state.general.formData,
    }

    obj.sustainable_development = obj.sustainable_development === 'true'
    obj.language = i18n.global.locale.value
    store.dispatch('checkEmail', { 'promoter_email': obj.promoter_email }).then(async (res: any) => {
      if (res) {
        store.dispatch('setLoading', false)
        if (res.type === 'particular') {
          const popup = {
            title: i18n.global.t(
              `proposal.form.popups.error.title`
            ),
            align: 'center',
            side: false,
            iconBg: 'bg-orange-5',
            icon: '/img/popup/exclamation_orange.svg',
            content: i18n.global.t(
              `proposal.form.popups.error.body`
            ),
            primaryButton: i18n.global.t(
              `proposal.form.popups.error.btn`
            ),
            sideBySideButtons: false
          }
          store.dispatch('setPopup', popup)
          resolve('done')
        }
        else {
          const type = !res.type ? 'register' : 'already_registered'
          const popup = {
            title: i18n.global.t(
              `proposal.form.popups.${type}.title`
            ),
            align: 'center',
            side: false,
            iconBg: 'bg-grey-6',
            icon: '/img/popup/personal_document.svg',
            content: i18n.global.t(
              `proposal.form.popups.${type}.body`
            ),
            primaryButton: i18n.global.t(
              `proposal.form.popups.${type}.btn`
            ),
            primaryLink: callback(obj, res),
            sideBySideButtons: false
          }
          await store.dispatch('setPopup', popup)
          store.dispatch('setLoading', false)
        }

      }
    }).catch((e: any) => {
      reject(e)
    })

  })
}

export default handle_submit
